import React from 'react';
// 임시 기본 값
const aTitle = 'Submit';

/**
 *
 * @property {JSX.Element} title
 * @property {JSX.Element} content
 */
const LinkBtn = ({ title = aTitle }) => {
  return (
    <button className="bg-opacity-40 p-3 min-w-[70px] text-sm bg-black font-TmoneyRoundWind font-bold text-white rounded-md">
      {title()}
    </button>
  );
};

export default LinkBtn;
